<!-- PrescriptionEducation.vue -->
<script setup lang="ts">
import CheckboxMapYN from '../../../components/Inputs/CheckboxMapYN.vue';
import SimpleFlexTable from '../../../components/Table/SimpleFlexTable.vue';
import SimpleFlexTableRow from '../../../components/Table/SimpleFlexTableRow.vue';
import { IPatientDecodeValue } from '../../../lib/Models/Patient/IPatientDecodeValue';

    const props = defineProps<{
        patientData: IPatientDecodeValue
    }>();

    enum ColIndex
    {
        Type,
        Consent
    }

    const emits = defineEmits(["update:patientData"]);
    function emitPatientData()
    {
        emits("update:patientData", props.patientData);
    }
</script>

<template>
    <SimpleFlexTable :columnClasses='["simple-cell TitleCol", "simple-cell"]'>
    <SimpleFlexTableRow rowClass="simple-row TitleRow">
            <template #cell="{colIndex}">
                <template v-if="ColIndex.Type == colIndex">
                    OptimizeRx Type
                </template>
                <template v-if="ColIndex.Consent == colIndex">
                    Consent
                </template>
            </template>
        </SimpleFlexTableRow>

        <SimpleFlexTableRow>
            <template #cell="{colIndex}">
                <template v-if="ColIndex.Type == colIndex">
                    Text Messages
                </template>
                <template v-if="ColIndex.Consent == colIndex">
                    <CheckboxMapYN
                        v-model="patientData.dfTextConsent" 
                        @update:modelValue="emitPatientData" />
                </template>
            </template>
        </SimpleFlexTableRow>
    </SimpleFlexTable>
</template>